import { InjectionToken } from '@angular/core';

export const STORAGE = new InjectionToken<string>("STORAGE");
export const SECURE_LOCAL_STORAGE = new InjectionToken<string>("SECURE_LOCAL_STORAGE");
export const SECURE_SESSION_STORAGE = new InjectionToken<string>("SECURE_SESSION_STORAGE");
